module.exports = __webpack_public_path__ + "img/leader_de_m.00937ab7.svg";